import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { SettlementsService } from "../shared/settlements.service";
import { SelectItem } from "primeng/api";
import { Table } from "primeng/table";
import trip from "@app/trip-new/shared/testing/trips/trip44";

@Component({
  selector: "app-settlement-detail",
  templateUrl: "./settlement-detail.component.html",
  styleUrls: ["./settlement-detail.component.css"],
})
export class SettlementDetailComponent implements OnInit {
  @ViewChild("dt", { static: true }) dataTable: Table;

  cols: any[];
  colsCharge: { field: string; header: string; width: number }[];
  driverChargeTypes: SelectItem[] = [];

  batchId: string;
  trips: any = [];
  batchInfo: any;
  totalEarnings = 0;

  filters = {
    tripNo: "",
    billTo: "",
    driverName: "",
    startDate: null,
    endDate: null,
    include: "",
    lessorId: "",
    driverNo: "",
  };

  constructor(
    private settlementsService: SettlementsService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.cols = [
      { field: "tripNo", header: "Trip No", width: 100 },
      { field: "billTo", header: "Bill To", width: 300 },
      { field: "lessorId", header: "Lessor ID", width: 100 },
      { field: "driverNo", header: "Driver ID", width: 100 },
      { field: "driverName", header: "Driver", width: 230 },
      { field: "startDate", header: "Start Date", type: "date" },
      { field: "endDate", header: "End Date", type: "date" },
      { field: "netNonTripExpense", header: "Total", type: "currency", width: 100 },
      { field: "include", header: "Include"},
    ];
    this.driverChargeTypes = this.activatedRoute.snapshot.data.chargeTypes.filter(
      (chargeType) => chargeType.value.expenseGL && !chargeType.value.isAccessorial
    );
    for (const chargeType of this.driverChargeTypes) {
      const { value } = chargeType;
      this.cols.push({
        field: `${value?.name}-MILES`,
        header: `${value?.name} MILES`,
        type: "number",
      });
      this.cols.push({
        field: `${value?.name}-UNITS`,
        header: `${value?.name} UNITS`,
        type: "number",
      });
      this.cols.push({
        field: `${value?.name}-RATE`,
        header: `${value?.name} RATE`,
        type: "number",
      });
      this.cols.push({
        field: `${value?.name}-PRICE`,
        header: `${value?.name} TOTAL`,
        type: "currency",
      });
    }

    this.activatedRoute.params.subscribe((params: Params) => {
      this.batchId = params["batchId"];
      this.getAllLoads();
      this.loadBatchInfo();
    });

  }

  isFilterable(field: string) {
    return Object.keys(this.filters).includes(field);
  }

  loadBatchInfo() {
    this.settlementsService.getBatch(this.batchId).subscribe((batchInfoResult: any) => {
      this.batchInfo = batchInfoResult;
    });
  }

  getAllLoads() {
    this.settlementsService.getAllLoadsForBatch(this.batchId).subscribe((res: any) => {
      if (!this.batchInfo.isOpen) {
        res = res.filter((trip) => trip.include);
      }
      res = res.map((trip) => ({
        ...trip,
        startDate: trip.startDate
          ? new Date(trip.startDate).toLocaleDateString()
          : null,
        endDate: trip.endDate ? new Date(trip.endDate).toLocaleDateString() : null,
      }));
      this.trips = this.createTripChargeColumns(res);
      this.calculateTotal();
    });
  }

  createTripChargeColumns(trips) {
    const tripSet = {};
    for (const trip of trips) {
      for (const charge of trip.driverCharges) {
        trip[`${charge.chargeType.name}-MILES`] = charge.miles;
        trip[`${charge.chargeType.name}-UNITS`] = charge.units;
        trip[`${charge.chargeType.name}-RATE`] = charge.chargeRate;
        trip[`${charge.chargeType.name}-PRICE`] = charge.price;
        tripSet[trip.id] = trip;
      }
    }
    return Object.values(tripSet);
  }

  calculateTotal() {
    // total earnings is the sum of all driver charges on all trips
    const sumDriverCharges = (trip) => {
      return trip.driverCharges.reduce((acc, charge) => {
        return acc + (charge.delete ? 0 : charge.price);
      }, 0);
    };

    for (const trip of this.trips) {
      trip.netNonTripExpense = sumDriverCharges(trip);
    }

    this.totalEarnings = this.trips
      .filter((trip) => trip.include)
      .reduce((acc, trip) => {
        return acc + trip.netNonTripExpense;
      }, 0);
  }

  excelGeneration() {
    const colNames = this.cols.map((col) => col.header);
    const colFields = this.cols.map((col) => col.field);

    const values = this.dataTable.filteredValue || this.trips;
    
    let plainRecords = values.map((trip) => {
      let tripRecord = [];
      for (const field of colFields) {
        const datatype = typeof trip[field];
        if (datatype === "string") trip[field] = trip[field].toUpperCase();
        if (trip[field] && trip[field].toString().includes(",")) {
          tripRecord.push(`"${trip[field]}"`);
        } else {
          tripRecord.push(trip[field] || "");
        }
      }
      return tripRecord;
    });
    plainRecords.unshift(colNames);
    let CsvString = "";
    for (const rowItem of plainRecords) {
      CsvString += rowItem.join(",") + "\r\n";
    }
    CsvString = "data:application/csv," + encodeURIComponent(CsvString);
    let x = document.createElement("A");
    x.setAttribute("href", CsvString);
    x.setAttribute("download", "settlementDetail" + new Date().toLocaleDateString() + ".csv");
    document.body.appendChild(x);
    x.click();
  }
}

/*
add lessor id
add driver id
title of page with batch number needs date range too
if batch is closed, don't show false trips
investigate missing data, such as driver dayrate
*/